import {
  IUnlockEligibleRecord,
  IUnlockEligibleResponse,
} from "@/@types/unlock-request";
import { DEFAULT_PAGE } from "@/constants/pagination";

export const unlockEligibleRecordKey = (
  record: IUnlockEligibleRecord,
): string => String(record.operatorCode ?? record.userCode ?? "");

export const mergeEligiblePages = (
  cached: IUnlockEligibleResponse,
  incoming: IUnlockEligibleResponse,
  page: number | undefined,
): IUnlockEligibleResponse => {
  if (!page || page <= DEFAULT_PAGE) return incoming;

  const known: Set<string> = new Set(cached.data.map(unlockEligibleRecordKey));
  const fresh: IUnlockEligibleRecord[] = incoming.data.filter(
    (record: IUnlockEligibleRecord): boolean =>
      !known.has(unlockEligibleRecordKey(record)),
  );

  return { ...incoming, data: [...cached.data, ...fresh] };
};
